import axios, { AxiosError } from 'axios';

export type BuilderVersionErrorCode =
  | 'builder_snapshot_mismatch'
  | 'run_replay_target_not_newer';

export type BuilderVersionErrorPayload = {
  code: BuilderVersionErrorCode;
  details: Record<string, unknown>;
  message: string | null;
};

export function getBuilderVersionErrorPayload(error: unknown): BuilderVersionErrorPayload | null {
  if (!axios.isAxiosError(error)) {
    return null;
  }

  const rawData = (error as AxiosError).response?.data;
  if (!isObjectRecord(rawData)) {
    return null;
  }

  const data = rawData as Record<string, unknown>;
  if (data.code !== 'builder_snapshot_mismatch' && data.code !== 'run_replay_target_not_newer') {
    return null;
  }
  if (!isObjectRecord(data.details)) {
    return null;
  }

  return {
    code: data.code,
    details: data.details,
    message: typeof data.message === 'string' ? data.message : null,
  };
}

export function normalizeSnapshotVersionId(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim();
  return normalizedValue ? normalizedValue : null;
}

function isObjectRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}
